<template>
  <div class="search-box"
    :class="[boxStyle,{'fright':!showInput}]">
    <div class="locate"
      v-show="local && show"
      @click.stop="locate">
      <span>{{currentCity.city_name ? currentCity.city_name : '深圳'}}</span>
      <img class="locate-arrow" :src="require('@/assets/images/home/icon_home_arrow_16@2x.png')">
    </div>
    <div class="search"
      @click.stop="search"
      v-show="showInput">
      <form action="#"
        target="frameFile"
        @submit.prevent="searchFocus()"
        class="form">
        <input class="box"
          id="myinput"
          type="search"
          maxlength="20"
          @focus="search_focus"
          @input="search_focus"
          @blur="search_blur"
          ref="searchBox"
          v-model="query"
          :placeholder="placeholder"
          :readonly="readonly">
        <em class="clearInput"
          v-show="clearInput"
          @click="resetSearch"></em>
        <iframe name='frameFile'
          style="display: none;"></iframe>
      </form>
    </div>
    <div class="cancel"
      @click.stop="cancel"
      v-show="!local">取消</div>
  </div>
</template>

<script>
import PopupCenter from '@/components/common/PopupCenter'

export default {
  name: 'search-box',
  components: {
    PopupCenter
  },
  data () {
    return {
      query: '',
      timer: '',
      clearInput: false,
      keywords: ''
    }
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    local: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    boxStyle: {
      type: String,
      default: ''
    },
    readonly: {
      type: String
    },
    currentCity: {
      type: Object,
      default: () => {
        return {
          city_name: '',
          city_id: ''
        }
      }
    },
    hideScreen: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    this.query = this.$route.query.keytitle
    this.$nextTick(() => {})
  },

  activated () {
    if (this.$route.query.keytitle && !this.$route.meta.isBack) {
      this.query = this.$route.query.keytitle
    }
  },

  methods: {
    search () {
      // this.local = false;
      // 触发搜索事件
      this.$emit('search', true, this.query)
    },

    closePopupCenter (item) {
      this.$emit('closePopupCenter', item)
    },

    resetSearch () {
      this.query = ''
    },
    search_focus () {
      $(window).scrollTop(0)
      if (this.query) {
        this.clearInput = true
        this.autoSearch()
      } else {
        this.clearInput = false
      }
    },
    search_blur () {
      setTimeout(() => {
        this.clearInput = false
      }, 5)
    },
    cancel () {
      // this.local = true;
      // this.query = '';
      this.$emit('cancel', false)
    },
    autoSearch () {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.$emit('isSearchFun', this.query)
      }, 200)
    },
    setQuery (query) {
      this.query = query || ''
    },
    focus () {
      $('input').focus()
    },
    locate () {
      this.$emit('locate')
    },
    searchFocus () {
      this.$emit('getSearchResult', this.query)
      document.activeElement.blur() // 软键盘收起
    }
    // changeQuery() {
    //   this.local = false;
    //   this.$emit("changeQuery", true, this.query);
    // }
  },
  updated () {},
  watch: {
    query () {
      this.autoSearch()
    },

    hideScreen (val) {
      alert(val)
    }
  }
}
</script>

<style lang="less" scoped>
// @import "../../assets/css/variable";
@image: "../../assets/images/";
@import "../../assets/css/icon";
// 单行省略
.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.search-box {
  display: flex;
  width: 100%;
  padding: 20/200rem 26/200rem 20/200rem 24/200rem;
  color: #2e2e2e;
  background: #fff;
  align-items: center;
  position: relative;
  z-index: 2;
  .PopupCenter {
    width: 148/200rem;
    box-sizing: border-box;
  }
  .locate {
    display: flex;
    align-items: center;
    .ellipsis;
    flex-shrink: 0;
    font-size: 32/200rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 44/200rem;
    &-arrow {
      width: 32/200rem;
      height: 32/200rem;
      margin: 0 20/200rem 0 2/200rem;
    }
  }
  .search {
    position: relative;
    display: flex;
    align-items: center;
    flex: 1;
    background: transparent;
    overflow: hidden;
    border-radius: 8/200rem;
    .form {
      width: 100%;
    }
    .box {
      font-size: 26/200rem;
      color: #999;
      width: 100%;
      height: 72/200rem;
      line-height: 0.17rem;
      padding: 20/200rem 0 18/200rem 72/200rem;
      background: #F7F7F7 url("@{image}home/icon_home_search_nor@2x.png") no-repeat 26/200rem 17/200rem;
      background-size: 40/200rem 40/200rem;
      background-position-y: center;
      &::-moz-placeholder {
        font-size: 24/200rem;
        line-height: 34/200rem;
        color: #CCCDCE;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      &::-webkit-input-placeholder {
        font-size: 24/200rem;
        line-height: 34/200rem;
        color: #CCCDCE;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      &:-ms-input-placeholder {
        font-size: 24/200rem;
        line-height: 34/200rem;
        color: #CCCDCE;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
    }

    .clearInput {
      position: absolute;
      width: 28/200rem;
      height: 28/200rem;
      background-image: url("@{image}clear_search.png");
      background-size: cover;
      right: 22/200rem;
      top: 50%;
      margin-top: -14/200rem;
    }
  }
  &.black {
    background-color: transparent;
    color: #666666;
    .search {
      font-size: 0;
      .box {
        height: 55/200rem;
        background: url("@{image}search-icon-black.png") no-repeat 26/200rem 15/200rem;
        background-size: 24/200rem 27/200rem;
        color: @color-text-d;
        &::-moz-placeholder {
          font-size: 26/200rem;
          color: #999;
        }
        &::-webkit-input-placeholder {
          font-size: 26/200rem;
          color: #999;
        }
        &:-ms-input-placeholder {
          font-size: 26/200rem;
          color: #999;
        }
      }
      .box[type="search"]::-webkit-search-cancel-button {
        -webkit-appearance: none; //此处只是去掉默认的小×
      }
    }
    .cancel {
      padding-left: 30/200rem;
      font-size: 28/200rem;
    }
  }
  &.white {
    color: #fff;
    .local {
      background-image: url("@{image}icon-local-2.png");
      background-repeat: no-repeat;
      background-size: 28/200rem 32/200rem;
      background-position: 76% 82%;
    }
  }
  &.fright {
    justify-content: flex-end;
    .local {
      // transform: scale(1.2);
    }
  }
}
</style>
